<h4 class="dialog-title text-center">{{ 'Edit' | translate }} {{data.typeName}}</h4>

<hr />

<app-progress-spinner [show]="isFormLoading"></app-progress-spinner>

<div class="mb-4">
  <div mat-dialog-content>
    <div class="row">
      <div class="col-md-3">
        <mat-form-field>
          <mat-label>{{ 'Icon' | translate }}</mat-label>
          <mat-select [(ngModel)]="customObject.icon" required>
            @for (icon of icons; track trackByIndex($index)) {
              <mat-option [value]="icon">
                <mat-icon>
                  <i [class]="icon"></i>
                </mat-icon>
              </mat-option>
            }
          </mat-select>
          @if (customObject.icon) {
            <mat-icon matPrefix>
              <i [class]="customObject.icon"></i>
            </mat-icon>
          }
          <mat-error>{{ 'Icon is required' | translate }}</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-9">
        <mat-form-field>
          <mat-label>{{ 'Name' | translate }}</mat-label>
          <input matInput [(ngModel)]="customObject.name" required />
          <mat-error>{{ 'Name is required' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <button class="btn button-primary" mat-button (click)="save()" [class.button-spinner]="isLoading"
      [disabled]="!customObject.name || !customObject.icon || isLoading">
      {{ 'Save' | translate }}
    </button>

    <button class="btn button-accent" mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
  </div>
</div>
